var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.0332,
    r: 20.5,
    fill: "#7069FD",
    stroke: "#7069FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9995 29.8993C25.8964 29.8993 29.8661 25.9296 29.8661 21.0327C29.8661 16.1358 25.8964 12.166 20.9995 12.166C16.1026 12.166 12.1328 16.1358 12.1328 21.0327C12.1328 22.4511 12.4659 23.7916 13.058 24.9806C13.2154 25.2965 13.2678 25.6576 13.1765 25.9985L12.6484 27.9724C12.4192 28.8291 13.203 29.613 14.0598 29.3838L16.0336 28.8557C16.3746 28.7644 16.7357 28.8168 17.0516 28.9741C18.2405 29.5663 19.5811 29.8993 20.9995 29.8993Z",
    stroke: "white",
    strokeWidth: 1.425
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 19.7012H24.5465",
    stroke: "white",
    strokeWidth: 1.425,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4531 22.8066H22.3298",
    stroke: "white",
    strokeWidth: 1.425,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickChatIcon);
export default __webpack_public_path__ + "static/media/QuickChatIcon.2c1e8653b3514be9cff08c55fc69e323.svg";
export { ForwardRef as ReactComponent };